import { render, staticRenderFns } from "./UpdateProfile.vue?vue&type=template&id=35056f96&scoped=true"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"
import style0 from "./UpdateProfile.vue?vue&type=style&index=0&id=35056f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35056f96",
  null
  
)

export default component.exports